import { Trans } from '@lingui/react'
import classnames from 'clsx'
import { type VFC } from 'react'

import './FreeShippingProgressBar.scss'
import { TENANT_CH } from 'shared/consts/tenants'

type PropTypes = {
  currentAmount: number
  freeShippingThreshold: number
  isFreeShipping: boolean
  missingAmountItem: JSX.Element
  shippingCost: number
  initialShippingCost: number
  size?: 'small' | 'normal'
  tenant: string
}

const FreeShippingProgressBar: VFC<PropTypes> = ({
  currentAmount,
  freeShippingThreshold,
  isFreeShipping,
  missingAmountItem,
  size = 'normal',
  tenant,
}) => {
  const percentageToFreeShipping = isFreeShipping
    ? 100
    : 100 / (freeShippingThreshold / currentAmount)

  const progressBarIndicatorValue =
    percentageToFreeShipping <= 100 ? percentageToFreeShipping : 100

  const currencyFormatedFreeShipping =
    tenant === TENANT_CH
      ? `CHF ${freeShippingThreshold}`
      : `${freeShippingThreshold} €`

  const progressBarElement = (
    <div
      className={
        'o-FreeShippingIndicator__progress u-background-color--background'
      }
    >
      <div
        style={{
          width: `${progressBarIndicatorValue}%`,
        }}
        className={classnames(
          'o-FreeShippingIndicator__progress ',
          {
            'u-background-color--positive': percentageToFreeShipping >= 100,
          },
          {
            'u-background-color--blue-light o-FreeShippingIndicator__progress-order-value':
              percentageToFreeShipping < 100,
          }
        )}
      />
    </div>
  )

  return (
    <div
      className={classnames(
        'o-FreeShippingIndicator l-flex l-flex--vertical u-position--relative u-padding-small--bottom@small-tiny',
        {
          'o-FreeShippingIndicator__small u-padding-small--top@small-tiny':
            size === 'small',
          'o-FreeShippingIndicator__normal': size === 'normal',
        }
      )}
    >
      <div className="o-FreeShippingIndicator__progressText a-full-width l-flex l-flex--distribute-space">
        <span
          className={classnames(
            'u-margin--right o-FreeShippingAddressBox__positive-free-shipping',
            {
              'u-color--positive l-flex': isFreeShipping,
            }
          )}
        >
          {isFreeShipping ? (
            <Trans id="freeShippingIndicator.label.freeShipping" />
          ) : (
            missingAmountItem
          )}
        </span>
        <span
          className={classnames({
            'u-color--positive': isFreeShipping,
            'o-FreeShippingThresholdText': !isFreeShipping,
          })}
        >
          {currencyFormatedFreeShipping}
        </span>
      </div>
      {progressBarElement}
    </div>
  )
}

export default FreeShippingProgressBar
